import AccountService from '@/services/AccountService';

export default {
  namespaced: true,
  state: {
    length: 0,
    list: null,
    listSorted: null,
    listSortedLength: 0,
    extract: null,
  },
  mutations: {
    m_length(state: any, length: Number) {
      state.length = length;
    },
    m_list(state: any, list: any) {
      state.list = list;
    },
    m_listSorted(state: any, list: any) {
      state.listSorted = list;
    },
    m_listSortedLength(state: any, length: Number) {
      state.listSortedLength = length;
    },
    m_extract(state: any, extract: any) {
      state.extract = extract;
    },
  },
  actions: {
    async a_init_Account({ dispatch }: any, { params }: any) {
      await dispatch('a_get_length');
      await dispatch('a_get_list');
      if (params) {
        if (params.getlistSorted) await dispatch('a_getlistSorted', params.getlistSorted);
        if (params.getlistSorted) await dispatch('a_get_listSortedLength', params.getlistSorted);
      }
    },
    async a_get_length({ commit }: any) {
      await AccountService.getAccountLength().then((res: any) => {
        if (res.status === 200) {
          commit('m_length', res.data.accountCount);
        }
      });
    },
    async a_get_list({ commit }: any) {
      await AccountService.getAccountList().then((res: any) => {
        if (res.status === 200) {
          commit('m_list', res.data);
        }
      });
    },
    async a_get_listSorted({ commit }: any, { month, year }: any) {
      await AccountService.getAccountByMonthAndYear({ month, year }).then((res: any) => {
        if (res.status === 200) {
          console.log(res.data);
          // commit('m_listSorted', res.data);
        }
      });
    },
    async a_get_listSortedLength({ commit }: any, { month, year }: any) {
      await AccountService.getAccountByMonthAndYearLength({ month, year }).then((res: any) => {
        if (res.status === 200) {
          commit('m_listSortedLength', res.data.accountCount);
        }
      });
    },
    async a_get_extract({ commit }: any, { params }: any) {
      await AccountService.getExtract(params).then((res: any) => {
        if (res.status === 200) {
          const blob = new Blob([res.data]);
          const url = URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = 'exportUsagers.csv';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      });
    },
  },
  getters: {
    length: (state: any) => state.length,
    list: (state: any) => state.length,
    listSorted: (state: any) => state.length,
    listSortedLength: (state: any) => state.listSortedLength,
    extract: (state: any) => state.extract,
  },
};
